import extensionPoints, { initExtensionPoints } from '../../extpoints'
import { SPARKY_FRAMEWORK } from '../../init/initConst'
import extensions from '../../extensions'
import type { BuiltInExtensionCandidate } from '../../framework/microAppTypes'

const builtInCandiate = {
  appName: SPARKY_FRAMEWORK,
  id: SPARKY_FRAMEWORK,
  initExtensionPoints,
  extensionPoints,
  extensions,
  isPure: false, // already added during init
} as BuiltInExtensionCandidate

export default builtInCandiate
